module.exports = __webpack_public_path__ + "static/media/Zanzibar-map-cutout-VP.6de3453a.png";